import { get } from 'lodash';
import { EMPTY_OBJECT } from '../../../constants/utils';

export const stats = state => get(state, 'auctioneers.stats', EMPTY_OBJECT);
export const areStatsLoading = state => get(state, 'auctioneers.stats.loading', false);
